const openAccordion = accordion => {
    const content = accordion.querySelector('[data-tab-content]');
    const title = accordion.querySelector('.faqs-block__title a');
    accordion.classList.add('is-active');
    title.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    content.style.display = null;
    content.style.maxHeight = content.scrollHeight + 42 + 'px';

    setTimeout(() => {
        const bounding = title.getBoundingClientRect()
        if (
            !(
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.right <= window.innerWidth &&
                bounding.bottom <= window.innerHeight
            )
        ) {
            title.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
    }, 300)

    const params = new URLSearchParams(location.search);
    params.set('question', title.id);
    window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
}

const closeAccordion = accordion => {
    // console.log(accordion)
    const content = accordion.querySelector('[data-tab-content]');
    const title = accordion.querySelector('.faqs-block__title a');
    const video = accordion.querySelector('.faqs-block__media-type-video');
    accordion.classList.remove('is-active');
    title.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = null;

    setTimeout(() => {
        if (!accordion.classList.contains('is-active')) {
            content.style.display = 'none'
        }
    }, 300)

    if (video) {
        const player = new Vimeo.Player(video.querySelector('iframe'));
        player.pause();
    }

    // Deep linking
    const params = new URLSearchParams(location.search);
    params.delete('question', '');
    window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);
}

const accordions = document.querySelectorAll('[data-accordion-item]');

if (accordions.length) {
    accordions.forEach(accordion => {
        const title = accordion.querySelector('.faqs-block__title a');
        const content = accordion.querySelector('[data-tab-content]');
        
        const parentH2 = accordion.closest('.taxonomy-index-block').querySelector('.faqs-block__section-heading');
        const categoryTxt = (!parentH2) ? 'NOT FOUND' : parentH2.textContent.trim();

        content.style.display = 'none';

        title.addEventListener('click', function (event) {
            event.preventDefault();

            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach(accordion => closeAccordion(accordion));
                openAccordion(accordion);
                if (typeof sega4 == 'object' && typeof sega4.faqPage == 'object' && typeof sega4.faqPage.accordion == 'function'){
                    sega4.faqPage.accordion(categoryTxt, title.textContent.trim());
                }
            }
        })
    })

    // Deep linking & initial open state
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    const query_string_accordion_title = document.getElementById(params.question);

    if (query_string_accordion_title) {
        setTimeout(() => {
            query_string_accordion_title.scrollIntoView({ behavior: 'smooth', block: 'start' });
            openAccordion(query_string_accordion_title.closest('[data-accordion-item]'));
        }, 300)
    } else {
        //  Initial tacit state, when no inbound query string question param provided. 
        //  Disabled 15 DEC 2022
        // openAccordion(accordions[0])
    }
}

